import React from 'react';
import styled from 'styled-components';
import { Content } from "../../components/Layout";
import { Flex } from '../../components/Flex';
import { Paragraph, Title } from '../../components/Text';
import { IconButton } from '../../icons/IconContainer';

const DashboardBox = styled(Flex).attrs({
    background: "#FFFFFF",
    align: 'center',
    gap: { right: 20 },
    height: "80px"
})`
    border-radius: 16px;
    padding: 0px 32px;
    cursor: pointer;
    flex: ${({ flex }) => flex};
    text-transform: capitalize;
    width: ${({ width }) => width};
    max-width: calc(25% - 32px);
    margin: 16px;
    color: #1C62D2;

    &:hover {
        color: var(--sp-main-color);
    }
`;

export const DashboardItem = ({ icon, title, onClick, ...props }) => (
    <DashboardBox onClick={onClick} {...props}>
        {icon && <IconButton background="#6092E2">
            {icon}
        </IconButton>}
        <Paragraph size="18px" lineHeight="20px" color="currentColor" bold>{title}</Paragraph>
    </DashboardBox>
)

const Dashboard = ({ tab, onClick, title, actions=[], content, firstLogin, fullName }) => {

    const makeGreeting = (firstLogin, fullName) => {
        let greeting = "Welcome";
        if (!firstLogin) {
            greeting += " back";
        };
        if (typeof fullName === "string") {
            greeting += ", " + fullName.split(" ")[0]
        }
        return greeting + "!"
    };

    return(
        <Content gap={{ bottom: 28 }}>
            {tab == "dashboard" && <Title h4 style={{ marginBottom: "16px"}}>{makeGreeting(firstLogin, fullName)}</Title>}
            {actions.length
                ? <>
                    <Title h4>{title}</Title>
                    <Flex wrap="wrap" margin={{ "left": "-16px", "top": "-16px", "right": "-16px", "bottom": "-16px"}}>
                        {actions.map((action, idx) =>
                            <DashboardItem
                                key={`action-${idx}`}
                                onClick={() => onClick(action.key)}
                                icon={action.icon}
                                title={action.title}
                                width={tab === "dashboard" ? undefined : "326px"}
                                flex={tab === "dashboard" ? "1 0 calc(25% - 32px)" : undefined}
                            />
                        )}
                    </Flex>
                </>
                : null}
            {content}
        </Content>
    );
};

export { Dashboard };